import axios from "../../../utils/axiosInstance";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import ReCAPTCHA from "react-google-recaptcha";

import "../../../css/bootstrap5.css";
import "./login.css";

import BasicInput from "../../edittext/basicInput/basicInput";
import PasswordInput from "../../edittext/passInput/passwordInput";
import ButtonSimp from "../../button";
import CheckBox from "../../button/checkbox/checkbox";
import LinearLayout from "../../layout/LinearLayout";


const Login = () => {
  const [email, setEmail] = useState("");
  const [address, setAddress] = useState("");
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const [rememberMe, setRememberMe] = useState(false);
  const [pendingSeller, setPendingSeller] = useState(false);
  const navigate = useNavigate();
  const [captchaValue, setCaptchaValue] = useState(null);
  const [isRegister, setIsRegister] = useState(false);
  const [captchaSize, setCaptchaSize] = useState("normal");
  useEffect(() => {
    const update = () => {
      setCaptchaSize(window.innerWidth <= 480 ? "compact" : "normal");
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);
  const handleLogin = async () => {
    if (!captchaValue) {
      alert("Please verify captcha");
      return;
    }
    console.log("user=" + email);
    console.log("user=" + password);
    try {
      const { data } = await axios.post("/auth/login", { email, password });
      const token = data.token;

      localStorage.setItem("token", token);
      if (rememberMe) {
        localStorage.setItem("userInfo", JSON.stringify(data.user));
      } else {
        sessionStorage.setItem("userInfo", JSON.stringify(data.user));
      }

      console.log("login=" + JSON.stringify(data));
      navigate("/dashboard");
    } catch (error) {
      alert("Login failed: " + error.response?.data?.message || error.message);
      console.error("❌ Login error:", error);
    }
  };

  const handleRegister = async () => {
    if (!captchaValue) {
      alert("Please verify captcha");
      return;
    }
    if (password !== confirmPassword) {
      alert("Passwords do not match");
      return;
    }
    if (!email || !password || !name || !address || !phone) {
      alert("Please complete the form.");
    }

    try {
      const { data } = await axios.post("/auth/register", {
        email,
        password,
        name,
        address,
        phone,
        roll: pendingSeller,
      });
      const token = data.token;

      localStorage.setItem("token", token);
      if (rememberMe) {
        localStorage.setItem("userInfo", JSON.stringify(data.user));
      } else {
        sessionStorage.setItem("userInfo", JSON.stringify(data.user));
      }

      console.log("register=" + JSON.stringify(data));
      navigate("/dashboard");
    } catch (error) {
      alert(
        "Register failed: " + error.response?.data?.message || error.message
      );
      console.error("❌ Register error:", error);
    }
  };

  return (
    <>
      <LinearLayout
        orientation="vertical"
        width="match-parent"
        className="mt-md-3 modal-body"
      >
        <LinearLayout orientation="horizontal" width="match-parent">
          <LinearLayout
            orientation="vertical"
            width="match-parent"
            gap={3}
            margin={1}
          >
            {/* <LinearLayout  margin={0} width="match-parent" xgravity="center" className="d-md-none">
              <img src={logo} alt="Logo" style={{ height: "25px" }} />
            </LinearLayout> */}
            {isRegister ? (
              <LinearLayout orientation="vertical" width="match-parent" gap={3} >
                <BasicInput
                  bsize="1"
                  bcolor="primary"
                  margin="0"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="Username"
                  value={email}
                  onChange={setEmail}
                />
                <LinearLayout
                  orientation="horizontal"
                  width="match-parent"
            
                  gap={1}
                >
                  <LinearLayout orientation="vertical" gap={3} >
                    <PasswordInput
                      bsize="1"
                      bcolor="primary"
                      margin="1"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Password"
                      value={password}
                      onChange={setPassword}
                    />
                    <PasswordInput
                      bsize="1"
                      bcolor="primary"
                      margin="1"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Confirm Password"
                      value={confirmPassword}
                      onChange={setConfirmPassword}
                    />
                  </LinearLayout>
                  <LinearLayout orientation="vertical" gap={3}>
                    <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="0"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Name"
                      value={name}
                      onChange={setName}
                    />
                    {/* <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="0"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Address"
                      value={address}
                      onChange={setAddress}
                    />{" "} */}
                    <BasicInput
                      bsize="1"
                      bcolor="primary"
                      margin="0"
                      bgcolor="white"
                      textcolor="black"
                      scolor="primary"
                      text="Phone"
                      value={phone}
                      onChange={setPhone}
                    />
                  </LinearLayout>
                </LinearLayout>
                <CheckBox
                  text="I want to be a seller."
                  checked={pendingSeller}
                  onChange={(e) => setPendingSeller(e.target.checked)}
                />
                <span
                  onClick={() => setIsRegister(false)}
                  style={{ cursor: "pointer", fontSize: "13px" }}
                  className="text-primary"
                >
                  Already have an account? Login here
                </span>
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    sitekey="6LcFcsUrAAAAALjpEmQaSit1oreAsXJOQ8IoGJY1"
                    onChange={(value) => setCaptchaValue(value)}
                    size={captchaSize}
                  />
                </div>
                <ButtonSimp
                  margin="3"
                  size="md"
                  padding="2"
                  text="Register"
                  clicked={handleRegister}
                  color="success"
                />
              </LinearLayout>
            ) : (
              <LinearLayout gap={3}>
                <BasicInput
                  bsize="1"
                  bcolor="primary"
                  margin="0"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="Username"
                  value={email}
                  onChange={setEmail}
                />
                <PasswordInput
                  bsize="1"
                  bcolor="primary"
                  margin="1"
                  bgcolor="white"
                  textcolor="black"
                  scolor="primary"
                  text="Password"
                  value={password}
                  onChange={setPassword}
                />
                <CheckBox
                  text="Remember me."
                  onChange={(e) => setRememberMe(e.target.checked)}
                />

                <span
                  onClick={() => setIsRegister(true)}
                  style={{ cursor: "pointer", fontSize: "13px" }}
                  className="text-primary"
                >
                  Don't have an account yet? Start here
                </span>
                <div className="recaptcha-wrapper">
                  <ReCAPTCHA
                    sitekey="6LcFcsUrAAAAALjpEmQaSit1oreAsXJOQ8IoGJY1"
                    onChange={(value) => setCaptchaValue(value)}
                    size={captchaSize}
                  />
                </div>
                <ButtonSimp
                  margin="3"
                  size="md"
                  padding="2"
                  text="Login"
                  clicked={handleLogin}
                  color="primary"
                />
              </LinearLayout>
            )}
          </LinearLayout>
          {/* <LinearLayout
            width="match-parent"
            className="mt-3 d-none d-md-block "
          >
            <img src={logo} alt="Logo" style={{ height: "100px" }} />
          </LinearLayout> */}
        </LinearLayout>
        {/* <LinearLayout xgravity="end" width="match-parent">
          <ButtonSimp
            margin="3"
            size="md"
            padding="2"
            color="primary"
            text="Login"
            clicked={handleLogin}
          />
        </LinearLayout> */}
      </LinearLayout>
    </>
  );
};

export default Login;

